import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../../Common/InputText';
import MultiSelectBox from '../../../Common/MultiSelectBox/MultiSelectBox';
import TextArea from '../../../Common/TextArea';
import Button from '../../../Common/Button';
import { MAX_NUM_FAQS } from '../../../../constants/constants';

export const SupportTicketsSection = (props) => {
	const onDefaultAgentChange = (id) => {
		const defaultAgentId = id ? id : '';
		props.onFormChange('defaultAgentUserId', defaultAgentId);
	};

	const onFAQChange = (faq, index, field, event) => {
		let faqs = props.subscription.FAQs.slice();
		const updatedFaq = { ...faq, [field]: event.target.value };
		faqs.splice(index, 1, updatedFaq);
		props.onFormChange('FAQs', faqs);
	};

	const addFAQ = () => {
		let faqs = props.subscription.FAQs.slice();
		if (faqs.length < MAX_NUM_FAQS) {
			faqs.push({
				id: 0,
				question: '',
				answer: '',
				isActive: true,
				ordinal: faqs.length,
			});
			props.onFormChange('FAQs', faqs);
		}
	};

	const removeFAQ = (index) => {
		let faqs = props.subscription.FAQs.slice();
		faqs.splice(index, 1);
		
		// Recalculate ordinals after removal
		faqs = faqs.map((faq, idx) => ({
			...faq,
			ordinal: idx
		}));
		
		if (faqs.length === 0) {
			faqs.push({
				id: 0,
				question: '',
				answer: '',
				isActive: true,
				ordinal: 0,
			});
		}
		props.onFormChange('FAQs', faqs);
	};

	const className = props.isFormValid ? 'support-tickets-form' : 'support-tickets-form was-validated';
	return (
		<div className='support-tickets-section section'>
			<form className={className} noValidate>
				<div className='row content'>
					<div className='col-12 col-md-4 header'>
						<h4>Support Tickets</h4>
						<p>
							Who should be notified when your colleagues create a support ticket? You can also create common FAQs that will display
							when your colleagues create a new ticket.
						</p>
					</div>
					<div className='col-12 col-md-8 fields'>
						<div className='row'>
							<div className='col-12 col-lg-6'>
								<MultiSelectBox
									name='defaultAgentUserId'
									label='Assign new support tickets to'
									idField='id'
									valueField='name'
									options={props.supportAgents}
									selectedValues={props.subscription.defaultAgentUserId.toString()}
									onChange={onDefaultAgentChange}
									isRequired={false}
									isMulti={false}
								/>
							</div>
							<div className='col-12 col-lg-6'>
								<div className='mb-3'>
									<strong>FAQ Questions and Answers</strong>
								</div>
							{props.subscription.FAQs.map((faq, index) => {
								// Use stable key: faq.id for existing items, fallback for new items (id: 0)
								const key = faq.id && faq.id !== 0 ? `faq-${faq.id}` : `new-faq-${faq.ordinal}`;
								return (
									<div key={key} className={`subscription-question${index + 1}`}>
											<InputText
												name='question'
												label={`Question ${index + 1}`}
												value={faq.question}
												placeholder='Question'
												onChange={(e) => onFAQChange(faq, index, 'question', e)}
												type='text'
												maxLength={256}
											/>
											<TextArea
												rows={4}
												name='answer'
												label={`Answer ${index + 1}`}
												value={faq.answer}
												placeholder='Answer'
												onChange={(e) => onFAQChange(faq, index, 'answer', e)}
												maxLength={1000}
											/>
											<Button
												name={`remove-question${index + 1}`}
												type='button'
												bootstrapClass='link question-remove'
												text='Remove'
												onClick={() => removeFAQ(index)}
												isDisabled={props.subscription.FAQs.length === 1}
											/>
										</div>
									);
								})}
								{props.subscription.FAQs.length < MAX_NUM_FAQS ? (
									<div className='col-12 no-left-padding'>
										<Button
											name='question-add'
											type='button'
											bootstrapClass='link question-add'
											text='Add Question'
											onClick={addFAQ}
										/>
									</div>
								) : (
									<div className='col-12 mb-2'>The maximum number of FAQs have been reached.</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

SupportTicketsSection.propTypes = {
	subscription: PropTypes.object.isRequired,
	isFormValid: PropTypes.bool.isRequired,
	onFormChange: PropTypes.func.isRequired,
	supportAgents: PropTypes.array.isRequired,
};

export default SupportTicketsSection;
